import { render, staticRenderFns } from "./CreateRoleModal.vue?vue&type=template&id=dfc0f3d4&"
import script from "./CreateRoleModal.vue?vue&type=script&lang=js&"
export * from "./CreateRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports